'use client'

import { ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import HeaderNew from '@/app/components/base/Header'
import LoanComparatorHeader from '@/app/components/loanComparator/LoanComparatorHeader'

const PATHS_WITHOUT_LOAN_HEADER = ['/simulation-assurance-pret-immobilier']

const COMPARATOR_CHROME_PREFIXES = [
    '/parcours-assurance-pret-immobilier',
    '/devis-assurance-pret-immobilier',
    '/coordonnees-assurance-pret-immobilier',
    '/resultats-assurance-pret-immobilier',
    '/adhesion-assurance-pret-immobilier',
]

interface Props {
    footer: ReactNode
    recoletaClass: string
    children: ReactNode
}

// Chrome piloté par usePathname : le layout serveur du groupe n'est rendu qu'une fois,
// son x-pathname reste donc figé sur la page d'entrée lors des navigations client
export default function LoanComparatorLayoutChrome({ footer, recoletaClass, children }: Props) {
    const pathname = usePathname() ?? ''
    const hasComparatorChrome = COMPARATOR_CHROME_PREFIXES.some((prefix) => pathname.startsWith(prefix))

    if (hasComparatorChrome) {
        return (
            <>
                <HeaderNew comparatorStyle />
                <div className={`bg-white md:min-h-screen md:bg-neutral ${recoletaClass}`}>
                    {children}
                </div>
                {footer}
            </>
        )
    }

    return (
        <>
            {!PATHS_WITHOUT_LOAN_HEADER.includes(pathname) && <LoanComparatorHeader />}
            <div className="min-h-screen">
                {children}
            </div>
        </>
    )
}
